/**
 * @prettier
 */

import { configReducer } from "./reducers/configReducer";
import { processedDataReducer } from "./reducers/processedDataReducer";
import { idPropertiesReducer } from "./reducers/idPropertiesReducer";
import { eVerificationReducer } from "./reducers/eVerificationReducer";
import { spinnerReducer } from "./reducers/spinnerReducer";
import { submissionStateReducer } from "./reducers/submissionStateReducer";
import { addressLookupReducer } from "./reducers/addressLookupReducer";
import { poaDocumentsReducer } from "./reducers/poaDocumentsReducer";

const rootReducer = {
    config: configReducer,
    processedData: processedDataReducer,
    idProperties: idPropertiesReducer,
    eVerification: eVerificationReducer,
    spinner: spinnerReducer,
    submissionState: submissionStateReducer,
    addressLookup: addressLookupReducer,
    poaDocuments: poaDocumentsReducer,
};

export default rootReducer;
